var exports = {
  "uk": "AgentsMenu__7p06A8",
  "Bp": "AgentsMenuStandalone__LGfgyL",
  "uJ": "OneCopilotMenu__udbkYB",
  "mO": "Wrapper__gliA6s",
  "U_": "NarrowLeadingSpace__EuAHbg",
  "Mw": "AnnouncementSlot__vhAhGZ",
  "xO": "AnnouncementGroup__udsydh",
  "K8": "CopilotMenu__oPrKz5",
};

module.exports = exports;
